import FormWithValidation from "./form-w-validation";
import PhoneNoInput from "../phone-no-input";
import classNames from "classnames";
import InputGuideText from "@/components/input-guide-text";
import ShippingPurposeSelector from "@/components/shipping-purpose-selector";

export default function SenderDetails({
  formData,
  senderValidationStates,
  updateFormData,
}) {
  const [
    { state: validSenderFirstName, setState: setValidSenderFirstName },
    { state: validSenderEmail, setState: setValidSenderEmail },
    { state: validSenderMobileNo, setState: setValidSenderMobileNo },
    { state: validPurpose, setState: setValidPurpose },
  ] = senderValidationStates;

  return (
    <>
      <div className="w-full">
        <div className="bg-white w-full md:rounded-xl shadow">
          <div className="w-[86%] md:w-[50%] mx-auto pt-6 pb-10 md:pt-8">
            <div className="relative">
              <div className="grid grid-cols-2">
                <p>Full Name</p>
                <p></p>
              </div>
              <div
                className={classNames(
                  "mt-1 relative border rounded-xl",
                  "flex items-center h-10 focus-within:border-light-purple focus:shadow-border-focus ",
                  !validSenderFirstName
                    ? "border-error-red shadow-border-error"
                    : "border-border-dark-gray shadow-border"
                )}
              >
                <input
                  type="text"
                  id="senderFirstName"
                  autoFocus
                  className={classNames(
                    "rounded-xl w-full h-full",
                    "focus:outline-none pl-3"
                  )}
                  placeholder="First name"
                  value={formData.senderFirstName}
                  onBlur={(e) => {
                    if (e.target.value.length > 0)
                      setValidSenderFirstName(true);
                    else setValidSenderFirstName(false);
                    updateFormData("senderFirstName", e.target.value);
                  }}
                  onChange={(event) => {
                    updateFormData("senderFirstName", event.target.value);
                  }}
                />
                <hr className="h-2/3 self-center border-l border-border-gray group-focus-within:border-light-purple" />
                <input
                  type="text"
                  id="senderLastName"
                  className={classNames(
                    "rounded-xl w-full h-full",
                    "focus:outline-none pl-3",
                    ""
                  )}
                  placeholder="Last name"
                  value={formData.senderLastName}
                  onBlur={(e) => {
                    updateFormData("senderLastName", e.target.value);
                  }}
                  onChange={(event) => {
                    updateFormData("senderLastName", event.target.value);
                  }}
                />
              </div>

              {validSenderFirstName ? (
                <InputGuideText className="mt-0.5 ml-0.5 mb-5">
                  Person whom JustShip contacts for packing & billing matters
                </InputGuideText>
              ) : (
                <InputGuideText className="mt-0.5 ml-0.5 mb-5" isWarning={true}>
                  Required
                </InputGuideText>
              )}
            </div>

            <FormWithValidation
              id="senderEmail"
              label="Sender's Email"
              type="email"
              category="email"
              state={formData.senderEmail}
              setState={(value) => updateFormData("senderEmail", value)}
              isValid={validSenderEmail}
              setIsValid={setValidSenderEmail}
            />
            <label
              htmlFor="shipping-from"
              className="font-normal text-subheading-gray "
            >
              Shipping From
            </label>
            <input
              type="text"
              id="shipping-from"
              disabled
              className={classNames(
                "mt-1 mb-6 relative rounded-xl border border-border-dark-gray flex group",
                "w-full h-10 pl-3 disabled:bg-gray-2 disabled:text-subtext-gray"
              )}
              value="Singapore"
            />
            <PhoneNoInput
              label="Sender's Mobile"
              callCode={formData.senderCallCode}
              setCallCode={(value) => updateFormData("senderCallCode", value)}
              name="senderMobileNo"
              type="mobile"
              state={formData.senderMobileNo}
              setState={(value) => updateFormData("senderMobileNo", value)}
              isValid={validSenderMobileNo}
              setIsValid={setValidSenderMobileNo}
            />
          </div>
        </div>
        <ShippingPurposeSelector
          selectedPurpose={formData.purpose}
          onPurposeChange={(value) => {
            updateFormData("purpose", value);
            setValidPurpose(true);
          }}
          isValid={validPurpose}
        />
      </div>
    </>
  );
}
